import React from "react";
import classNames from "classnames";
import { DropdownHoverProps } from "./DropdownHover";

export interface DropdownBodyProps extends DropdownHoverProps {
  /**
   * Whether the dropdown body is visible.
   */
  isVisible: boolean;

  /**
   * Additional classnames for this element.
   */
  className?: string;
}

export const DropdownBody: React.FC<DropdownBodyProps> = ({ isVisible, className, onFocus, onBlur, ...rest }) => {
  return (
    <div
      className={classNames("dropdown__body", className, {
        "u-visually-hidden": !isVisible,
      })}
      onMouseOver={onFocus}
      onMouseOut={onBlur}
      onFocus={onFocus}
      onBlur={onBlur}
      {...rest}
    />
  );
}

DropdownBody.displayName = "DropdownBody";
